export class RealtimePollingRequestParameters {
  chart: any;
  range: any;
  machineId: number;
  organizationId: number;
  firebaseUserId?: string|null;
  chartId?: number | null;
  timestamp: number | null;
  initial: boolean;
  refresh: number | null;
  sampling: number | null;
  pageId?: number | null;
  templateWidget: boolean;
  latestOnly: boolean;

  constructor(params: InputParams) {
    this.machineId = params.machineId;
    this.organizationId = params.organizationId;
    this.firebaseUserId = params.firebaseUserId || null;
    this.chartId = params.chartId || null;
    this.timestamp = params.timestamp || 0;
    this.initial = !!params.initial;
    this.refresh = params.refresh || 0;
    this.sampling = params.sampling || 0;
    this.pageId = params.pageId || null;
    this.templateWidget = params.templateWidget || false;
    this.latestOnly = params.latestOnly || false;
  }
}

export interface InputParams {
  machineId: number;
  organizationId: number;
  refresh: number;
  initial?: boolean;
  sampling?: number;
  timestamp?: number;
  chartId?: number;
  pageId?: number;
  firebaseUserId?: string;

  templateWidget?: boolean;
  latestOnly?: boolean;
}
